import { render } from "./KhyberPakhtunkhwa.vue?vue&type=template&id=c3fa8d0e&scoped=true"
const script = {}

import "./KhyberPakhtunkhwa.vue?vue&type=style&index=0&id=c3fa8d0e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3fa8d0e"]])

export default __exports__